const IMG = "https://static.prod-images.emergentagent.com/jobs/d44bff62-9371-4a9a-addd-16d45e830582/images/";

export const IMAGES = {
  hero: IMG + "db9cb93e478b1e85f87fdac013c5856e4d8dd11c7fe8d14455482494f46bce1c.jpeg",
  "blue-sapphire": IMG + "03990ba0d08ed792a5f2bc7693b49df2ac9b2bf35fd496c29777591b769d1e45.jpeg",
  "yellow-sapphire": IMG + "53cca8a24221f3f1b23311429ef617dd651cc539535d028105b76f1877e404fc.jpeg",
  ruby: IMG + "dcf5672d9b32cba185d53db9ad8e972e885d6fe67cb234cc0ce676a9f04a03ac.jpeg",
  emerald: IMG + "5fb264e9da071f66b923ac3566b5a341b24173568bd141b944b7997007bc8332.jpeg",
  "red-coral": IMG + "8ffa1289908ad432aaf887f07e87c79d46587e97d2bb93795d4cee9f919621bd.jpeg",
  pearl: IMG + "5ae00e4d64c4f7000e23d65acb0f42e0350c2772e99b2599764948d24a703f39.jpeg",
  hessonite: IMG + "d7c51507c0ce77eff3a3600b18d1fce5cf7b67511b4b94f4dec8cd160a085985.jpeg",
  "cats-eye": IMG + "d85edda5baedb397342ffcc442a2fea659c0ee176a05a72b1a3d6e7a96b50c44.jpeg",
  "white-sapphire": IMG + "0cc0ef1f80d4187ca57d5aaf721184fa1620d3d2d71ccdaf4a53f7b69cb6b9bc.jpeg",
  rudraksha: IMG + "a5fc8c28110c23a172a299164d1fb7a22c698735bbbd1f7569124f5b7ddae6cf.jpeg",
  xray: IMG + "03ce8218ec32d0a5a5d74a6da6ba75eb9a1feedb0e4c14c4ce0deb12051265a6.jpeg",
  mala: IMG + "ad7aa7354a528737d27a9ab7cbacf190e569ac83804efc5676c2cb40f1e5bc12.jpeg",
  certificate: IMG + "a15a1a97f4a16ebb1c64bcb5a6e724e73c8353d0ebee84274d67d4338d695448.jpeg",
  sourcing: IMG + "70ce90c3e9384d48d6dc7a6f6274b5e5b4233f75b0aa0bea2ee01a2af3d8d0c4.jpeg",
  pendant: IMG + "216f9958c92c70eae9d6c960ee162812b93b9b7ebbc8fdf96ce54e0ab3079db6.jpeg",
  yantra: IMG + "65f0c483ad1c8091caa734bf3ac3b8224142827d20d74588f8069d99c2a555a6.jpeg",
};

export const INTENT_IMAGE = {
  "wealth-abundance": IMAGES["yellow-sapphire"],
  protection: IMAGES["red-coral"],
  "clarity-focus": IMAGES.emerald,
  relationships: IMAGES.pearl,
  "career-work": IMAGES.ruby,
  "study-learning": IMAGES["white-sapphire"],
  "peace-of-mind": IMAGES.rudraksha,
};

export const PLANET_IMAGE = {
  sun: IMAGES.ruby,
  moon: IMAGES.pearl,
  mangal: IMAGES["red-coral"],
  budh: IMAGES.emerald,
  guru: IMAGES["yellow-sapphire"],
  shukra: IMAGES["white-sapphire"],
  shani: IMAGES["blue-sapphire"],
  rahu: IMAGES.hessonite,
  ketu: IMAGES["cats-eye"],
};
